@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;


$border-label: v.$palette-gray-300;
$border-label-active: v.$palette-blue;
$border-circle: v.$palette-gray-400;
$color: v.$palette-gray-900;

.label {
  display: block;
  user-select: none;
}

.inputDefaultHide {
  position: absolute;
  appearance: none;
  width: 1px;
  height: 1px;
  clip: rect(0 0 0 0);
  margin: -1px;
  border: 0;
  padding: 0;
  overflow: hidden;

  &:checked + .radio {
    border: 1px solid $border-label-active;
    box-shadow: 0 7px 16px rgba(1, 57, 255, 0.08);

    .circle {
      border: 1px solid $border-label-active;

      &::before {
        content: '';
        display: block;
        position: absolute;
        margin: auto;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $border-label-active;
        border-radius: 50%;
        width: 0.5714285714283em;
        height: 0.5714285714283em;
      }
    }
  }
}

.radio {
  cursor: pointer;
  border: 1px solid $border-label;
  border-radius: 6px;
  padding: 8px 6px 8px 18px;
  @include t.text(14px, 22px, 400);
  display: flex;
  align-items: center;
}

.circle {
  position: relative;
  width: 1.14285714286em;
  height: 1.14285714286em;
  border: 1px solid $border-circle;
  border-radius: 50%;
  margin-right: 10px;
}

.title {
  color: $color;
}
